import { HttpErrorResponse } from '@angular/common/http';
import { createAction } from '@ngrx/store';
import { ContextInfo } from '../models/login.model';

export const loadUserRequest = createAction('[User] Load User Request');

export const loadUserSuccess = createAction('[User/API] Load User Success', (contextInfo: ContextInfo) => ({
  contextInfo,
}));

export const loadUserFail = createAction('[User/API] Load User Fail', (err: HttpErrorResponse) => ({ err }));

export const logout = createAction('[User] Logout');
